<ng-container *ngIf="initialData">
  <ifbp-form-details-base-view [initialData]="initialData"></ifbp-form-details-base-view>
</ng-container>
